export default {
  device: {
    checkLoading: 'Checking....',
    check: 'Check',
    checkTitle: 'Device check',
    checkResult: 'Check result',
    checkItem: 'Check item',
    checkSuccess: 'success'
  },
  hybird: {
    id: 'ID',
    status: 'state',
    userName: 'User Name',
    companyName: 'Company Name',
    companyId: 'Company Id',
    activeCode: 'Activation code',
    createdTime: 'Created Time',
    searchPlaceholder: 'Please enter your username or company name',
    active: 'Active',
    unActive: 'not activated'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/en/v6.js